import { Box, Grid, Link, Paper, Stack, Typography } from "@mui/material";
import { PlusCircle } from "lucide-react";
import ItemImage from "./ItemImage";
import { HEADING_FONT } from "../constants/colors";

const CATEGORIES = [
  { href: "/gear/tents", src: "/xmid2.png", label: "Tents" },
  { href: "/gear/sleeping-pads", src: "/helix.png", label: "Sleeping Pads" },
  { href: "/gear/backpacks", src: "/reiflash.png", label: "Backpacks" },
  {
    href: "/gear/sleeping-bags",
    src: "/ee_down.png",
    label: "Sleeping Bags and Quilts",
  },
  {
    href: "/gear/insulated-jackets",
    src: "/cumulus.png",
    label: "Insulated Jackets",
  },
  { href: "/gear/stoves", src: "/pocketrocket.png", label: "Stoves" },
];

const DEALS_CARD = {
  href: "/gear",
  src: "https://storage.googleapis.com/pack_wizard/gear/generic/deal.png",
  label: "Daily Deals",
};

const cardSx = (theme) => {
  const isDark = theme.palette.mode === "dark";
  return {
    height: "205px",
    width: "250px",
    borderRadius: "16px",
    overflow: "hidden",
    border: `1px solid ${
      isDark ? "rgba(255,255,255,0.1)" : "rgba(0,0,0,0.08)"
    }`,
    backgroundImage: "none",
    transition:
      "transform 0.25s ease, box-shadow 0.25s ease, border-color 0.25s ease",
    "&:hover": {
      transform: "translateY(-6px)",
      cursor: "pointer",
      boxShadow: isDark
        ? "0 18px 36px rgba(0,0,0,0.45)"
        : "0 18px 36px rgba(25,118,210,0.14)",
      borderColor: isDark
        ? "rgba(144,202,249,0.45)"
        : "rgba(25,118,210,0.35)",
    },
  };
};

const GearExploreCard = ({ href, src, label }) => (
  <Grid item>
    <Link href={href} sx={{ textDecoration: "none" }}>
      <Paper elevation={0} sx={cardSx}>
        <Stack>
          <Box sx={{ width: "250px", height: "150px", position: "relative" }}>
            <ItemImage
              style={{
                maxWidth: "230px",
                maxHeight: "130px",
                position: "absolute",
                margin: "auto",
                top: "0",
                bottom: "0",
                left: "0",
                right: "0",
              }}
              src={src}
              alt={label}
            />
          </Box>
          <Typography
            sx={{
              textAlign: "center",
              fontFamily: HEADING_FONT,
              fontWeight: 600,
              fontSize: "14.5px",
              padding: "10px 12px",
            }}
          >
            {label}
          </Typography>
        </Stack>
      </Paper>
    </Link>
  </Grid>
);

const GearExploreList = ({ justifyContent, showDeals }) => {
  return (
    <Stack>
      <Grid
        container
        spacing={2}
        justifyContent={justifyContent}
        sx={{ maxWidth: "1200px" }}
      >
        {CATEGORIES.map((category) => (
          <GearExploreCard key={category.href} {...category} />
        ))}
        {showDeals ? <GearExploreCard {...DEALS_CARD} /> : <></>}
      </Grid>
      <Link
        href="/gear/submit"
        underline="hover"
        sx={{
          display: "inline-flex",
          alignItems: "center",
          gap: "6px",
          alignSelf: justifyContent === "center" ? "center" : "flex-start",
          marginTop: "14px",
          fontFamily: HEADING_FONT,
          fontWeight: 600,
          fontSize: "14px",
        }}
      >
        <PlusCircle size={16} />
        Know gear we're missing? Submit it
      </Link>
    </Stack>
  );
};

export default GearExploreList;
